import { render, staticRenderFns } from "./z-it-staff-data.vue?vue&type=template&id=522dfe68&"
import script from "./z-it-staff-data.vue?vue&type=script&lang=ts&"
export * from "./z-it-staff-data.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports